function n(e, c) {
  return c ? e.replace(/\/?\/$/, "") + "/" + c.replace(/^\/+/, "") : e;
}
export {
  n as default
};
